import apiClient from "./apiClient";

export const staffService = {
    /**
     * Create a new staff member (Vendor Staff or Vendorless Unit Admin Staff)
     * @param {Object} payload 
     */
    createStaff: async (payload) => {
        return apiClient.post('/staff-management/staff/CreateStaff', payload);
    },

    /**
     * Get staff roles. Pass categoryId to list only roles saved under that vendor category.
     * @param {number|string|{ siteId?: number|string, categoryId?: number|string }} siteIdOrParams
     */
    getStaffRoles: async (siteIdOrParams) => {
        const source = typeof siteIdOrParams === "object" && siteIdOrParams !== null
            ? siteIdOrParams
            : { siteId: siteIdOrParams };
        const params = {};
        if (source.siteId) params.siteId = source.siteId;
        if (source.categoryId) params.categoryId = source.categoryId;
        return apiClient.get('/staff-management/staff/GetRoles', { params });
    },

    createStaffRole: async (payload) => {
        return apiClient.post('/staff-management/staff/CreateRole', payload);
    },

    updateStaffRole: async (staffRoleId, payload) => {
        return apiClient.put(`/staff-management/staff/UpdateRole?staffRoleId=${staffRoleId}`, payload);
    },

    deleteStaff: async (staffId, modifiedBy) => {
        return apiClient.put('/staff-management/staff/DeleteStaff', null, {
            params: { staffId, modifiedBy }
        });
    },

    createStaffLogin: async (payload) => {
        return apiClient.post('/staff-management/staff-login/Create', payload);
    },

    getStaffLogins: async (vendorId) => {
        return apiClient.get('/staff-management/staff-login/GetByVendor', {
            params: { vendorId }
        });
    },

    setStaffLoginStatus: async (payload) => {
        return apiClient.put('/staff-management/staff-login/SetStatus', payload);
    },

    /**
     * Get staff list with filtering & pagination
     * @param {Object} params 
     */
    getStaff: async (params) => {
        return apiClient.get('/staff-management/staff/GetStaff', {
            params
        });
    },

    /**
     * Update existing staff member
     * @param {number|string} staffId
     * @param {Object} payload
     */
    updateStaff: async (staffId, payload) => {
        return apiClient.put(`/staff-management/staff/UpdateStaff?staffId=${staffId}`, payload);
    },

    /**
     * Allot or update duty shift for a staff member
     * @param {Object} payload
     */
    allotDuty: async (payload) => {
        return apiClient.post('/staff-management/staff/AllotDuty', payload);
    },

    /**
     * Update duty allotment for a staff member
     * @param {number|string} allotmentId
     * @param {Object} payload
     */
    updateAllotment: async (allotmentId, payload) => {
        return apiClient.post(`/staff-management/staff/UpdateAllotment?allotmentId=${allotmentId}`, payload);
    },

    /**
     * Upload identity document for an existing staff member
     * @param {Object} payload - { staffId, documentType, documentNumber, fileName, filePath, createdBy }
     */
    uploadStaffDocument: async (payload) => {
        return apiClient.post('/staff-management/staff/UploadDocument', payload);
    },

    /**
     * Get vendors for vendor selection dropdown
     * @param {Object} params 
     */
    getVendors: async (params) => {
        return apiClient.get('/vendor-management/vendor/GetVendors', {
            params
        });
    },

    /**
     * Get shifts for staff based on personTypeId (3 = staff)
     * @param {number|string} personTypeId 
     */
    getShifts: async (personTypeId = 3) => {
        return apiClient.get('/shift-master/GetShifts', {
            params: { personTypeId }
        });
    }
};

export default staffService;
